import api from '../api/axios';

const getConfigs = () => {
  return api.get('/integrations/config');
};

const getConfig = (name) => {
  return api.get(`/integrations/config/${name}`);
};

const updateConfig = (name, data) => {
  return api.put(`/integrations/config/${name}`, data);
};

const testConnection = (name) => {
  return api.post(`/integrations/config/${name}/test`);
};

const getForemanDocSettings = () => {
  return api.get('/integrations/foreman-doc-settings');
};

const getLogsForProposal = (proposalId) => {
  return api.get(`/integrations/logs/proposal/${proposalId}`);
};

const retryIntegration = (logId) => {
  return api.post(`/integrations/logs/${logId}/retry`);
};

const sendToWarehouse = (proposalId) => {
  return api.post(`/integrations/send/${proposalId}/warehouse`);
};

const sendToDelivery = (proposalId) => {
  return api.post(`/integrations/send/${proposalId}/delivery`);
};

const sendToAll = (proposalId) => {
  return api.post(`/integrations/send/${proposalId}/all`);
};

// Legacy CRM
const searchLegacyProposal = (query) => {
  return api.get(`/integrations/legacy/search?q=${encodeURIComponent(query)}`);
};

const getLegacyProposal = (proposalId) => {
  return api.get(`/integrations/legacy/proposal/${proposalId}`);
};

const getLegacyPropertyNotes = (address) => {
  return api.get(`/integrations/legacy/property/notes?address=${encodeURIComponent(address)}`);
};

const getLegacyInstallations = (startDate, endDate) => {
  return api.get(`/integrations/legacy/installations?startDate=${startDate}&endDate=${endDate}`);
};

// Equipment sync
const syncEquipment = (proposalId) => {
  return api.post(`/integrations/sync-equipment/${proposalId}`);
};

// Sync equipment to a property by arbitrary PO number (searched in Warehouse)
const syncEquipmentByPo = (propertyId, poNumber) => {
  return api.post(`/integrations/sync-equipment-by-po/${propertyId}/${encodeURIComponent(poNumber)}`);
};

// Get equipment from Warehouse by PO number
const getWarehouseEquipment = (poNumber) => {
  return api.get(`/integrations/warehouse/equipment/${poNumber}`);
};

// Get Samsara fleet vehicles (for mapping a technician to a vehicle)
const getSamsaraVehicles = () => {
  return api.get('/integrations/samsara/vehicles');
};

// Get recognition data (equipment + supplies) from Warehouse by PO number
const getRecognitionData = (poNumber) => {
  return api.get(`/integrations/warehouse/recognition/${poNumber}`);
};

// Batch check which POs have equipment with serial numbers in Warehouse
const batchSerialCheck = (poNumbers) => {
  return api.post('/integrations/warehouse/equipment/batch-serial-check', { poNumbers });
};

// Delivery Unavailability (Time Off)
const getDeliveryTechnicians = () => {
  return api.get('/integrations/delivery/technicians');
};

const getDeliveryUsers = () => {
  return api.get('/integrations/delivery/users');
};

const getDeliveryUnavailability = () => {
  return api.get('/integrations/delivery/unavailability');
};

const getDeliveryUserUnavailability = (userId) => {
  return api.get(`/integrations/delivery/unavailability/user/${userId}`);
};

const createDeliveryUnavailability = (data) => {
  return api.post('/integrations/delivery/unavailability', data);
};

const updateDeliveryUnavailability = (id, data) => {
  return api.put(`/integrations/delivery/unavailability/${id}`, data);
};

const deleteDeliveryUnavailability = (id) => {
  return api.delete(`/integrations/delivery/unavailability/${id}`);
};

const integrationServices = {
  getSamsaraVehicles,
  getConfigs,
  getConfig,
  updateConfig,
  testConnection,
  getForemanDocSettings,
  getLogsForProposal,
  retryIntegration,
  sendToWarehouse,
  sendToDelivery,
  sendToAll,
  searchLegacyProposal,
  getLegacyProposal,
  getLegacyPropertyNotes,
  getLegacyInstallations,
  syncEquipment,
  syncEquipmentByPo,
  getWarehouseEquipment,
  getRecognitionData,
  batchSerialCheck,
  // Delivery Time Off
  getDeliveryTechnicians,
  getDeliveryUsers,
  getDeliveryUnavailability,
  getDeliveryUserUnavailability,
  createDeliveryUnavailability,
  updateDeliveryUnavailability,
  deleteDeliveryUnavailability,
};

export default integrationServices;
